import React, {useEffect} from 'react';
import DemoDemoProvider, { DemoConsumer } from '../lib/DemoProvider'
import Main from './Main';
import '../style/App.css';

function App() {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${process.env.REACT_APP_DISDK_PROD_URL}/cdn/remove-background/lib/remove-background.js`;
    script.async = true;
    script.onload = () => window.rbsInit();
    document.body.appendChild(script);
  }, [])

  return (
    <React.Fragment>
      <div className="app">
        <DemoDemoProvider>
          <DemoConsumer>
              {() => (
                <Main />
              )}
          </DemoConsumer>
        </DemoDemoProvider>
      </div>
    </React.Fragment>
  );
}

export default App;
